import { render, staticRenderFns } from "./ModalIntegracao.vue?vue&type=template&id=2c3ed2f9&scoped=true"
import script from "./ModalIntegracao.vue?vue&type=script&lang=js"
export * from "./ModalIntegracao.vue?vue&type=script&lang=js"
import style0 from "./ModalIntegracao.vue?vue&type=style&index=0&id=2c3ed2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ed2f9",
  null
  
)

export default component.exports